import React from 'react';

import Table from 'components/Table';
import Button from 'components/Button';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import positiveIcon from './assets/positive-icon.svg';
import negativeIcon from './assets/negative-icon.svg';
import viewIcon from './assets/view-icon.svg';
import AgreementStatus from 'components/AgreementStatus';

import './styles.css';

const AgreementsTable = ({
  agreements,
  openAddAgreementModal,
  openAgreementDetailModal,
  downloadAgreement
}) => (
  <div className="AgreementsTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Title" />
        <Table.HeaderItem heading="Type" />
        <Table.HeaderItem heading="Primary" />
        <Table.HeaderItem heading="Secondary" />
        <Table.HeaderItem heading="Guarantor" />
        <Table.HeaderItem heading="Agent" />
        <Table.HeaderItem heading="Status" />
        <Table.HeaderItem heading="View" />
      </Table.Header>
      <Table.Body>
        {agreements.map(agreement => (
          <Table.Row
            key={agreement.id}
            onClick={() => openAgreementDetailModal(agreement.id)}>
            <Table.Cell>{agreement.title}</Table.Cell>
            <Table.Cell>{agreement.type}</Table.Cell>
            <Table.Cell>
              {agreement.primaryTenantSignatureStatus === true && (
                <img src={positiveIcon} alt="Positive icon" />
              )}
              {agreement.primaryTenantSignatureStatus === false && (
                <img src={negativeIcon} alt="Negative icon" />
              )}
              {agreement.primaryTenantSignatureStatus === null && '-'}
            </Table.Cell>
            <Table.Cell>
              {agreement.secondaryTenantSignatureStatus === true && (
                <img src={positiveIcon} alt="Positive icon" />
              )}
              {agreement.secondaryTenantSignatureStatus === false && (
                <img src={negativeIcon} alt="Negative icon" />
              )}
              {agreement.secondaryTenantSignatureStatus === null && '-'}
            </Table.Cell>
            <Table.Cell>
              {agreement.guarantorSignatureStatus === true && (
                <img src={positiveIcon} alt="Positive icon" />
              )}
              {agreement.guarantorSignatureStatus === false && (
                <img src={negativeIcon} alt="Negative icon" />
              )}
              {agreement.guarantorSignatureStatus === null && '-'}
            </Table.Cell>
            <Table.Cell>
              {agreement.agentSignatureStatus === true && (
                <img src={positiveIcon} alt="Positive icon" />
              )}
              {agreement.agentSignatureStatus === false && (
                <img src={negativeIcon} alt="Negative icon" />
              )}
              {agreement.agentSignatureStatus === null && '-'}
            </Table.Cell>
            <Table.Cell>
              <AgreementStatus status={agreement.status} />
            </Table.Cell>
            <Table.Cell>
              <ClickIconWithNoPropagation
                onClick={() => {
                  agreement.contractUrl &&
                    downloadAgreement(agreement.contractUrl);
                }}>
                <img src={viewIcon} alt="View contract" />
              </ClickIconWithNoPropagation>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    <div className="options">
      <Button blue className="addAgreement" onClick={openAddAgreementModal}>
        Add agreement
      </Button>
    </div>
  </div>
);

export default AgreementsTable;
